import * as React from 'react';
import { useIsDesktop } from '@cian/valuation-utils-component';

import { QuestionLayout, IQuestionLayoutProps } from '../../components/QuestionLayout';
import { formContextObj } from '../FormContainer';

/**
 * Контейнер для QuestionLayout
 * Прокидывает в футер текст соглашения, только для 1го вопроса и только для десктопа
 * Прокидывает ссылку на каталог риелторов только для первого вопроса
 * */
export const QuestionLayoutContainer: React.FC<React.PropsWithChildren<IQuestionLayoutProps>> = props => {
  const { footer: propsFooter } = props;
  const { stepsHistory } = React.useContext(formContextObj);
  const stepsHistoryLength = stepsHistory.length;
  const isDesktop = useIsDesktop();

  const linkElement: React.ReactNode = null;

  const footer = React.useMemo(() => {
    if (stepsHistoryLength === 1) {
      return <>{linkElement}</>;
    }

    return propsFooter;
  }, [stepsHistoryLength, propsFooter, isDesktop, linkElement]);

  return <QuestionLayout {...props} footer={footer} />;
};

QuestionLayoutContainer.displayName = 'QuestionLayoutContainer';
